import { render, staticRenderFns } from "./InquiryDetailSidebar.vue?vue&type=template&id=31eca570&scoped=true"
import script from "./InquiryDetailSidebar.vue?vue&type=script&lang=js"
export * from "./InquiryDetailSidebar.vue?vue&type=script&lang=js"
import style0 from "./InquiryDetailSidebar.vue?vue&type=style&index=0&id=31eca570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eca570",
  null
  
)

export default component.exports